<template>
    <vx-expandable-card>
        <template v-slot:header>Documentation</template>
        <template v-slot:content>
            <div class="mb-4">
                When the Acuity integration is connected, calendar appointments scheduled via Acuity will automatically
                create new contacts in Voxie.
            </div>
            <div class="mb-4">Voxie will collect the following contact data from Acuity:</div>
            <ul class="list-disc list-inside mb-4">
                <li>Phone number</li>
                <li>Email address</li>
                <li>First name</li>
                <li>Last name</li>
                <li>Time-zone</li>
                <li>
                    Contact custom attributes:
                    <ul class="list-disc list-inside pl-4 mt-1">
                        <li><code>acuity_meeting_date_time</code></li>
                        <li><code>acuity_meeting_type</code></li>
                    </ul>
                </li>
            </ul>
            <div class="mb-4">
                Voxie Franchise Hub customers can also map Acuity appointment types to Voxie groups so that contacts are
                automatically attached to a group when their appointment is scheduled.
            </div>
            <div>
                The data mapping detailed above can be customized to fit your specific use case. Contact Voxie Support
                for more details.
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup lang="ts">
import { VxExpandableCard } from '@voxie/frontend-components';
</script>
